import script from "./BoatInfoElement.vue?vue&type=script&setup=true&lang=js"
export * from "./BoatInfoElement.vue?vue&type=script&setup=true&lang=js"

import "./BoatInfoElement.vue?vue&type=style&index=0&id=485ef4f3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-485ef4f3"]])

export default __exports__